// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, getCreditHistoryClient } from "../../Utils/Constants";
import { toast } from "react-toastify";

export const hitGetCreditHistoryClientApi = createAsyncThunk(
  "hitGetCreditHistoryClientApi",
  async () => {
    try {
      const config = {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          Authorization: `${localStorage.getItem("clientToken")}`,
        },
        params: {
         // search,
        },
      };
      const url = ApiBaseUrl + getCreditHistoryClient;
      const response = await axios.get(url, config);
      return response.data;
    } catch (error) {
      toast.error(error.response.data.message);
      throw error.response.data;
    }
  }
);

const GetCreditHistoryClientSlice = createSlice({
  name: "getCreditHistoryClientReducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearhitGetCreditHistoryClientData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitGetCreditHistoryClientApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitGetCreditHistoryClientApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(hitGetCreditHistoryClientApi.rejected, (state) => {
        state.isError = false;
      });
  },
});

export const { clearhitGetCreditHistoryClientData } = GetCreditHistoryClientSlice.actions;
export default GetCreditHistoryClientSlice.reducer;
